import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { InitService } from '../../services/init.service';
import { LoginService } from '../../services/login.service';
import { LoginRequest } from '../../shared/interfaces/login-request.interface';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {

  constructor(
    private toastr: ToastrService,
    private loginService: LoginService,
    private initService: InitService
  ) {}
  
  ngOnInit(): void {
  }

  password: string = "";
  username: string = "";
  code: string = "";
  loading: boolean = false;
  token: string = "";
  @Input() success: boolean = false;

  login() {
    const body: LoginRequest = {
      consumerToken: environment.auth_params.consumerToken,
      username: this.username,
      password: this.password,
      tenantId: this.initService.tenantConfigurations?.tenantId
    };

    this.loginService.login(body).subscribe(
      (res) => {
        this.loading = false;
        this.success = true;
        this.token = res.token;
      },
      (err) => {
        this.loading = false;
        if (err.error !== null && err.error.messages !== undefined) {
          this.toastr.error(err.error.messages[0], 'Ops');
        }
        else {
          this.toastr.error('Usuário ou senha inválidos', 'Ops!');
        }
      });
  }

  getImgSrc() {
    if (this.initService.tenantConfigurations?.iconUrl) {
      return this.initService.tenantConfigurations?.iconUrl;
    }
    return "../../../../assets/images/header-logo.svg";
  }
}
